import React from 'react';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import '../../assets/admin/css/login.css';
import '../../assets/admin/css/admin.scss';
import GetInvolvedTable from '../admin/getInvolvedTable';
import DonationTable from '../admin/donationTable';
import Sidebar from './sidebar';
import AddActivitie from '../admin/activitiesEntry';
import GetActivitiesTable from '../admin/getActivitiesTable';
import SponsorsGallery from './SponsorGallery';
import AddUnderprivilege from './addunderpeivilege';
import CoSponsors from './addNewCoSponsor';
import AddAnnualReport from './addAnnualReport';
import UploadMeta from './Addmeta';

class AdminLayout extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
         <>
   <div class="main-panel">
    <div class="content-wrapper">
        <div className='row'>
        <div className='col-12 col-lg-2'>
          <Sidebar {...this.state} {...this.props}/>
       </div>

       <div className="col-12 col-lg-10">
         { this.props.location.pathname !== '/AddActivitie' && 
           <div class="card">
           <div class="card-body">
           {this.props.location.pathname === '/GetInvolvedList' && 
              <>
              <h4 class="card-title">Get Involved List</h4>
              <GetInvolvedTable/>
              </>
           }
           {this.props.location.pathname === '/DonationList' && 
              <>
              <h4 class="card-title">Donation List</h4>
              <DonationTable/>
              </>
           }
           {this.props.location.pathname === '/ActivitieList' && 
              <>
              <h4 class="card-title">ActivitieList</h4>
              <GetActivitiesTable/>
              </>
           }
           {this.props.location.pathname === '/addgallery' && 
              <>
              <h4 class="card-title">Add Gallery</h4>
              <SponsorsGallery/>
              </>
           }
            {this.props.location.pathname === '/addUnderprivilege' && 
              <>
              <h4 class="card-title">Add Underprivilege Gallery</h4>
              <AddUnderprivilege/>
              </>
           }
            {this.props.location.pathname === '/CoSponsor' && 
              <>
              <h4 class="card-title">Add Co Sponsor</h4>
              <CoSponsors/>
              </>
           }
           {this.props.location.pathname === '/addAnnualReport' && 
              <>
              
              <AddAnnualReport/>
              </>
        }
          {this.props.location.pathname === '/addmeta' && 
              <>
              
              <UploadMeta/>
              </>
        }
          </div>
           </div>  
         }

         {this.props.location.pathname === '/AddActivitie' && 
              <>
              
              <AddActivitie/>
              </>
        }
        
       </div>
        </div>
     
    </div>
    </div>
         </>
    );
  }
}
export default withRouter(AdminLayout);